import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Plus } from "lucide-react";
import { toast } from "sonner";
import { useCart } from "@/context/CartContext";
import Price from "@/components/Price";

export default function ProductCard({ product, i = 0 }) {
  const { addItem } = useCart();
  const testId = `product-card-${product.slug.replace(/-kit$/, "").replace(/-/g, "-")}`;

  const quickAdd = (e) => {
    e.preventDefault();
    addItem(product);
    toast.success(`${product.name} added to order`);
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.6, delay: i * 0.07, ease: [0.22, 1, 0.36, 1] }}
      whileHover={{ y: -6 }}
      className="group relative border border-girder bg-steel/60 transition-[border-color,box-shadow] duration-300 hover:border-hivis/60 hover:shadow-[0_0_40px_-12px_rgba(245,158,11,0.25)]"
      data-testid={testId}
    >
      <Link to={`/products/${product.slug}`} className="block" data-testid={`${testId}-link`}>
        <div className="relative aspect-[4/3] overflow-hidden clip-corner bg-obsidian">
          <img
            src={product.card_image || product.images?.[0]}
            alt={product.name}
            loading="lazy"
            className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-obsidian/80 via-transparent to-transparent" />
          {product.badge && (
            <span className="absolute left-3 top-3 bg-hivis px-2 py-0.5 font-mono text-[10px] font-bold uppercase tracking-widest text-obsidian">
              {product.badge}
            </span>
          )}
        </div>
        <div className="p-5">
          <h3 className="font-display text-2xl font-bold uppercase leading-none tracking-tight text-slate-100">{product.name}</h3>
          <p className="mt-1.5 line-clamp-1 text-sm text-slate-400">{product.tagline}</p>
          <div className="mt-4 flex items-center justify-between">
            <Price product={product} />
            <button
              onClick={quickAdd}
              data-testid={`${testId}-quick-add`}
              aria-label={`Add ${product.name} to cart`}
              className="flex h-9 w-9 items-center justify-center clip-corner-sm bg-girder text-slate-200 transition-colors duration-200 hover:bg-hivis hover:text-obsidian"
            >
              <Plus className="h-4 w-4" />
            </button>
          </div>
        </div>
      </Link>
    </motion.div>
  );
}
